import script from "./AchievementTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementTable.vue?vue&type=script&setup=true&lang=js"

import "./AchievementTable.vue?vue&type=style&index=0&id=590fc1c1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-590fc1c1"]])

export default __exports__